import { getPartnerAdminBrands } from './admin';
import {
  ApiUserBrand,
  BrandChangeCallback, BrandChangeStop, getBrandById,
  getBrands,
  getSelectedBrand, onBrandChange,
  setSelectedBrand,
} from './brands';
import { addConsent, ApiUserConsent, getConsents } from './consents';
import { ApiUserPreferences, getPreferences } from './preferences';


export class GooseUser {
  async addConsent(productId: string): Promise<void> {
    return addConsent(productId);
  }

  async getConsents(): Promise<ApiUserConsent[]> {
    const [grantedConsent] = await getConsents();
    return grantedConsent;
  }

  async getPendingConsents(): Promise<ApiUserConsent[]> {
    const [_, pendingConsent] = await getConsents();
    return pendingConsent;
  }

  async getBrands(productId: string): Promise<ApiUserBrand[]> {
    return getBrands(productId);
  }

  async getPartnerAdminBrands(): Promise<string[]> {
    return (await getPartnerAdminBrands()).brands ?? [];
  }

  async getPartnerAdminMissingAccess(): Promise<GooseApiPartnerAdminBrandsMissingAccess[]> {
    return (await getPartnerAdminBrands()).missingAccess ?? [];
  }

  async getPreferences(): Promise<ApiUserPreferences> {
    return getPreferences();
  }

  async getBrandById(productId: string, brandId: string): Promise<ApiUserBrand | null> {
    const response: ApiUserBrand | undefined = await getBrandById(productId, brandId);

    let brand: ApiUserBrand | null = null;

    if (response) {
      brand = response;
    }

    return brand;
  }

  async getSelectedBrand(productId: string): Promise<ApiUserBrand | null> {
    return getSelectedBrand(productId);
  }

  async setSelectedBrand(brand: ApiUserBrand) {
    await setSelectedBrand(brand);
  }

  onBrandChange(cb: BrandChangeCallback): BrandChangeStop {
    return onBrandChange(cb);
  }
}
